import React, { useState, useEffect } from "react";
import { getPosts } from "../services/postService";
import { useParams } from "react-router-dom";
import "./PostList.css"; // 引入樣式
import PostCard from "./PostCard";

const PostList = () => {
  const { topicId } = useParams();
  const [posts, setPosts] = useState([]);
  const [topic, setTopic] = useState(null);
  const [loading, setLoading] = useState(true); // 新增 loading 狀態
  const [error, setError] = useState(null); // 新增 error 狀態

  useEffect(() => {
    const fetchPosts = async () => {
      setLoading(true); // 開始載入
      setError(null); // 清除錯誤
      try {
        const data = await getPosts(topicId);
        setPosts(data.posts);
        setTopic(data.topic);
      } catch (error) {
        console.error("Failed to fetch posts:", error);
        setError("無法載入貼文，請稍後再試。");
      } finally {
        setLoading(false); // 結束載入
      }
    };
    fetchPosts();
  }, [topicId]);

  return (
    <section className="post-list-container">
      <header className="post-list-header">
        <h2>{topic ? topic.name : "載入中..."}</h2>
        <p>{topic?.description}</p>
        
        {/* 顯示版主信息 */}
        {topic?.moderator_info && (
          <div className="topic-moderator-info">
            <span className="moderator-label">版主：</span>
            <span className="moderator-name">
              {topic.moderator_info.username}
            </span>
            <span className="moderator-role">
              ({topic.moderator_info.role_display})
            </span>
          </div>
        )}
        
        {!topic?.moderator_info && topic && (
          <div className="topic-moderator-info">
            <span className="moderator-label">版主：</span>
            <span className="no-moderator">暫無指定版主</span>
          </div>
        )}
      </header>

      {loading ? (
        <div className="post-list-loading">
          <div className="loading-spinner"></div>
          <p>正在載入貼文...</p>
        </div>
      ) : error ? (
        <div className="post-list-error">
          <span className="error-icon">!</span>
          <p>{error}</p>
          <button onClick={() => window.location.reload()}>重試</button>
        </div>
      ) : posts.length > 0 ? (
        <div className="post-list">
          {posts.map((post) => (
            <PostCard key={post.id} post={post} />
          ))}
        </div>
      ) : (
        <div className="post-list-empty">
          <span className="empty-icon">📭</span>
          <p>目前尚無貼文</p>
          <span className="empty-hint">成為第一個分享故事的人！</span>
        </div>
      )}
    </section>
  );
};

export default PostList;
